import { cva } from 'class-variance-authority';

export const iconVariants = cva(
  [
    'w-sizing-sys-size-24',
    'h-sizing-sys-size-24',
    'min-w-sizing-sys-size-24',
    'min-h-sizing-sys-size-24',
  ],
  {
    variants: {
      // Use `text-*` so the color flows via `currentColor` into both the
      // inline `<svg>` and the sprite `<use>` shadow tree. `[&>svg]:fill-current`
      // applies `fill: currentColor` to the inline branch's `<svg>`; the
      // sprite branch's path already declares `fill="currentColor"` and picks
      // up the same color from the inherited `color`.
      variant: {
        info: 'text-color-ref-ui-icon-strong [&>svg]:fill-current',
        success: 'text-color-ref-ui-status-success [&>svg]:fill-current',
        warning: 'text-color-ref-ui-status-warning [&>svg]:fill-current',
        error: 'text-color-ref-ui-status-danger [&>svg]:fill-current',
      },
    },
  },
);
